import React, { useEffect, useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useTrackVisibility } from 'react-intersection-observer-hook';
// slices
import { setMainLists, companySelector } from 'slices/company';
import { userSelector } from 'slices/user';
//api
import { getActivities } from 'api/company';
import { slidersClient } from 'api/products';
import { getPosts } from 'api/blog';
import { getAllLists } from 'api/lists';
import NoLists from 'components/userzone/NoLists';
//components
import ListHome from './listHome';
import PromotionalBanner from './bannerPromotional';
import SectionAffiliate from './sectionAffiliate';
import EventHome from './events';
import Head from 'components/metatags_helmet/metatags';
import PaginationLoader from 'components/loader/PaginationLoader';
import SectionLoader from 'components/loader/SectionLoader';
import Slider from 'components/slider';

const Home = () => {
  const [sliders, setSliders] = useState([]);
  const [events, setEvents] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [lists, setLists] = useState([]);
  const company = useSelector(companySelector);
  const {
    mainLists,
    descripcion_pub,
    is_single_company,
    has_slider,
    has_events,
    has_blog,
    home_image
  } = company;
  const { isLogged } = useSelector(userSelector);
  const dispatch = useDispatch();
  //pagination
  const [ref, { isVisible }] = useTrackVisibility();
  const [isLoading, setIsLoading] = useState(true);
  const [next, setNext] = useState(null);
  const [maxPage, setMaxPage] = useState(null);
  const [page, setPage] = useState(1);

  async function loadEvents() {
    const response = await getActivities({
      page: 1,
      page_size: 3,
      actives: true
    });

    if (response?.status === 200) {
      let events = response?.data?.results.slice(0, 3);
      setEvents(events);
    }
  }

  async function loadBlogs() {
    const { status, data } = await getPosts({ page_size: 4 });
    if (status === 200) {
      setBlogs(data?.results);
    }
  }

  async function getSlidersClient() {
    const { status, data } = await slidersClient({ type_str: "home", active: true });
    if (status === 200) {
      setSliders(data?.results);
    }
  }

  const handleLoadLists = async (page = 1) => {
    setIsLoading(true);
    const payload = {
      page: page,
      page_size: 3,
      location_web: 'home',
      estado: true,
      have_products: true,
      fields: 'id,favorite,products,contenido,nombre,url',
    };
    try {
      const { status, data } = await getAllLists(payload);
      if (status === 200) {
        setLists((prev) => (page === 1 ? data?.results : [...prev, ...data?.results]));
        setMaxPage(data?.total_pages);
        setNext(data?.next);
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const getAllListsAside = async () => {
    const payload = {
      // page: page,
      // page_size: 3,
      location_web: 'none',
      estado: true,
      have_products: true,
      fields: 'id,favorite,contenido,nombre,url',
    };
    try {

      const { status, data } = await getAllLists(payload);

      if (status === 200) {
        dispatch(setMainLists(data.results));
      }

    } catch (error) {
      console.log(error);
    }
  };

  // first call
  useEffect(() => {
    getAllListsAside();
    handleLoadLists();
    goUp();
  }, []);

  useEffect(() => {
    if (has_events) {
      loadEvents();
    }
  }, [has_events]);

  useEffect(() => {
    if (has_blog) {
      loadBlogs();
    }
  }, [has_blog]);

  const goUp = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    if (!isLogged) {
      setLists([]);
      setSliders([]);
      handleLoadLists();
      loadEvents();
      getSlidersClient();
    } else if (has_slider) {
      getSlidersClient();
    }
  }, [isLogged, has_slider]);

  // next API calls
  useEffect(() => {
    if (page < maxPage && next) {
      const getNewItems = async (newValuePage) => {
        await handleLoadLists(newValuePage);
        setPage(newValuePage);
      };
      if (isVisible) {
        let newValuePage = page + 1;
        getNewItems(newValuePage);
      }
    }
  }, [isVisible]);


  const showLists = !isLoading && lists?.length > 0;
  const showNoLists = !isLoading && (!lists || lists.length === 0);

  return (
    <>
      <Head description={descripcion_pub} title="" home={true} />
      <Container className="container-fluid mainDiv">
        <Row>
          <Col lg={12}>{sliders?.length > 0 && <Slider elements={sliders} />}</Col>
          <Col lg={9}>
            {isLoading && <SectionLoader />}
            {showLists && lists.map((item, i) => (
              <React.Fragment key={`ListHome${i}`}>
                <ListHome data={item} />
                {(i === 1 && home_image !== '') && (
                  <PromotionalBanner />
                )}
              </React.Fragment>
            ))}
            {showNoLists && <NoLists icon={true} />}
            {!isLoading && next && <div aria-hidden="true" ref={ref}></div>}
          </Col>
          <Col lg={3}>
            <EventHome blogs={blogs} events={events} lists={mainLists} />
          </Col>
          {
            !is_single_company && (
              <Col md={12} className="mt-5 ">
                <SectionAffiliate />
              </Col>
            )
          }
        </Row>
      </Container>
    </>
  );
};

export default Home;
